module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABWUlEQVR4Xu1aMQrCQBDcRURrO8U/pLEQFPQb+hAf4UP0GwoKFjb+QbSzVkROIggpTJwusDPpArPmZnZu73bRjfxxcv4mAeQAcgW0BcgNoCL42QKHw6l/fz2Xnmyavye3TbvRXAyH2RlxSDE+mXWRmLowbnYt8vN88Y/X85SSdYqLcrdbq9HM/olQFl8XQfS7X36+2R9Xlmz2M9BtPR0N5lU/WhmPrqYunNvat7vjpcy2uV0m40Gvan1V8XXxQr+b85MA9FuAvgjSH4NowYiKUy8QNbMoLzkAVSoqTg6ImlmUlxyAKhUVJwdEzSzKSw6gb4bo22H6gYhmguxDUfotQF8E6Y9B9MYUFaebYNTMorzkAFSpqDg5IGpmUV5yAKpUVJwcEDWzKC85gL4Zom+H6QcimglqJkj+V1n6Ikh/DKI3pqg43QSjZhblJQegSkXFyQFRM4vyonfAG1qXkFK2RPGBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav.png
// module id = NMl0
// module chunks = 1